import { render, staticRenderFns } from "./Wap_WXCW81_SXXBJ_Record.vue?vue&type=template&id=0b2f8199&scoped=true&"
import script from "./Wap_WXCW81_SXXBJ_Record.vue?vue&type=script&lang=js&"
export * from "./Wap_WXCW81_SXXBJ_Record.vue?vue&type=script&lang=js&"
import style0 from "./Wap_WXCW81_SXXBJ_Record.vue?vue&type=style&index=0&id=0b2f8199&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2f8199",
  null
  
)

export default component.exports